import { type SortByKeys, SORT_BY_KEYS } from '@/constants/search'
import { type DropdownItem } from '@/ui/molecules/dropdown'

/** Verifies if the sorting dropdown option is a valid one */
export const isSortByDropdownValueValid = (value: DropdownItem['value']): value is SortByKeys =>
  Object.values(SORT_BY_KEYS).includes(value as SortByKeys)
